import { useLayoutEffect, useEffect } from 'react';
/**
 * It gives useLayout effect if browser else useEffect
 */
export const useIsomorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
